import { gatewayInstance } from "../server/gateway";

/**
 * 答案同步
 * @param options
 * @returns
 */
export async function messagePush(options: any): Promise<any> {
  return gatewayInstance.request({
    api: "llm.push",
    method: "POST",
    // @ts-ignore
    body: options
  }) as any;
}

/**
 * 获取配置
 * @returns
 */
export async function
getAllLLMSetting(params = {}): Promise<any[]> {
  const res = (await gatewayInstance.request({
    api: "llm.setting",
    method: "POST",
    // @ts-ignore
    body: params
  })) as any;
  return res || {};
}

/**
 * 停止生成
 * @returns
 */
export async function messageStop(options: any): Promise<any> {
  try {
    const res = (await gatewayInstance.request({
      api: "llm.stop",
      method: "POST",
      // @ts-ignore
      body: options
    })) as any;
    return res || {};
  } catch (e) {
    return {};
  }
}

export async function fileSummary(options: any): Promise<any[]> {
  return gatewayInstance.request({
    api: "llm.fileSummary",
    method: "POST",
    // @ts-ignore
    body: options
  }) as any;
}

// 消息摘要
export async function messageSummary(options: any): Promise<any[]> {
  return gatewayInstance.request({
    api: "llm.messageSummary",
    method: "POST",
    // @ts-ignore
    body: options
  }) as any;
}

// 获取反馈标签
export async function getFeedbackTags(): Promise<any[]> {
  return gatewayInstance.request({
    api: "llm.getFeedbackTags",
    method: "POST",
    // @ts-ignore
    body: {}
  }) as any;
}

// 反馈
export async function postFeedback(options: any): Promise<any> {
  return gatewayInstance.request({
    api: "llm.feedback",
    method: "POST",
    // @ts-ignore
    body: options
  }) as any;
}

/**
 * 感知文本消息是否包括模型场景
 * @param options
 * @returns
 */
export async function messageDetect(options: any): Promise<any> {
  return gatewayInstance.request({
    api: "llm.messageDetect",
    method: "POST",
    // @ts-ignore
    body: options
  }) as any;
}

/**
 * 转发摘要
 * @param options
 * @returns
 */
export async function getForwardMessageSummary(options: any): Promise<any> {
  return gatewayInstance.request({
    api: "llm.forwardMessageSummary",
    method: "POST",
    // @ts-ignore
    body: options
  }) as any;
}
// 获取wps授权码
export async function getWpsPreviewCode(options: any): Promise<any> {
  return gatewayInstance.request({
    api: "llm.generateDocumentAuthCode",
    method: "POST",
    // @ts-ignore
    body: options
  }) as any;
}

export async function getExtractPersonInfo(options: any): Promise<any> {
  return gatewayInstance.request({
    api: "llm.extractPersonInfo",
    method: "POST",
    // @ts-ignore
    body: options
  }) as any;
}

// 智能体列表
export async function getAgentList(): Promise<any> {
  return gatewayInstance.request({
    api: "llm.agentList",
    method: "POST",
    // @ts-ignore
    body: {}
  }) as any;
}
